enum EquipmentCategory {
    VeneerProductionEquipment,
    VeneerProcessingEquipment,
    PlywoodProductionEquipment,
    PlywoodProductionSupportEquipment,
    PlywoodProcessingEquipment,
}

export default EquipmentCategory;
